import React from 'react';

import { withEventScope } from '@repo/event-processor';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { TextSection } from './TextSection';
import { TextSectionRow } from './TextSectionRow';
import { TextWithTitleProps } from './types';

const TextWithTitle: React.FC<TextWithTitleProps> = ({
  showInRow,
  sections,
}) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        {showInRow ? (
          <TextSectionRow textSections={sections} />
        ) : (
          <TextSection textSections={sections} />
        )}
      </ComponentContainer>
    </ComponentWrapper>
  );
};

export default withEventScope(TextWithTitle, { module: 'textWithTitle' });
